import {BaseTerms} from "../../infrastructure/models/base-terms";

export class StandingsWidgetTerms extends BaseTerms {
  GAME_CENTER_STANDING_POSITION = "Current Standings Position";
  STANDINGS_LEGEND = "Legend";
  STANDINGS_PLAYED = "Matches Played";
  STANDINGS_WINS = "Wins";
  STANDINGS_DRAWS = "Draws";
  STANDINGS_LOSSES = "Losses";
  STANDINGS_FOR_AGAINST = "Goal scores vs conceded";
  STANDINGS_TOTAL_POINTS = "Total points";
  TOOLTIP_GOAL_DIFFERENCE = "Goal Difference";
  TOOLTIP_STANDINGS_FORM = "Last results, from left to right";
  GAME_CENTER_H2H_DRAW = "D";
  GAME_CENTER_H2H_WIN = "W";
  GAME_CENTER_H2H_LOSE = "L";
  STANDINGS_PREVIOUS_POSITIONS = "Previous Position";
  WEB_STANDINGS_WON_TITLE = "Won title";
  WEB_STANDINGS_PREVIEW_SEE_FULL_STANDINGS = "See Full Standings";
  WEB_STANDINGS_PREVIEW_SEE_FULL_GROUPS = "See Full Group Standings";
  WEB_GAME_COMPETITION_STANDINGS_BUTTON = "#COMPETITION_NAME Standings";
  WEB_GAME_COMPETITION_GROUPS_BUTTON = "#COMPETITION_NAME Groups";
  WEB_GAME_COMPETITION_RANKING_BUTTON = "#COMPETITION_NAME";
  WEB_SEE_COMPETITOR_STANDINGS = '#COMPETITOR_NAME Standings';
  WEB_SEE_COMPETITOR_GROUPS = '#COMPETITOR_NAME Group Standings';
  WEB_STANDING_TIEBREAKERS_CARD_HEADER = "#COMPETITION_NAME tie-breakers";
  WEB_POINTS_CORRECTION = "#COMPETITION_NAME Points Corrections";
}
